import React from "react";
import { useIntl } from "react-intl";
import { getMessageValue } from "@ignitesales/neuro-application/src/i18n/messageUtil";
import RuleEvaluator from "../utils/ruleEvaluator/RuleEvaluator.mjs";

const ruleEval = new RuleEvaluator({ debug: false });

const LabelWithRuleEvaluation = (props) => {
  const { idArray, showIfNoRulePresent = true, answers = {} } = props;
  const answerObj = answers || {};
  const answersCleaned = [];
  for (let [key, value] of Object.entries(answerObj)) {
    answersCleaned.push(value);
  }
  let tests = idArray.map((id) => {
    ruleEval.setAnswers(answersCleaned);
    const intl = useIntl();
    const ruleMessage = getMessageValue(intl.locale, `${id}.rule`);
    const ruleIsValid = ruleMessage ? ruleEval.isTrue(ruleMessage) : false;
    return ruleIsValid || (!ruleMessage && showIfNoRulePresent);
  });
  const isFalse = (value) => value === false;
  return !tests.every(isFalse);
};

export default LabelWithRuleEvaluation;
